<template>
  <div class="container">
    <div class="filter">
      <el-row class="row">
        <el-col :span="1" class="col">行业：</el-col>
        <el-col :span="3" class="col">
          <el-select
            v-model="industry"
            placeholder="请选择"
            size="mini"
            @change="queryAdIdeas"
          >
            <el-option key="" label="全部" value=""></el-option>
            <el-option
              v-for="item in industyArr"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2" class="col" :offset="1">文案类型</el-col>
        <el-col :span="3" class="col">
          <el-select
            v-model="type"
            placeholder="请选择"
            size="mini"
            @change="queryAdIdeas"
          >
            <el-option key="" label="全部" value=""></el-option>
            <el-option
              v-for="item in typeArr"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-col>
        <!-- <el-col :span="1" :offset="1" class="col">时间</el-col>
        <el-col :span="3" class="col">
          <el-select
            v-model="time"
            placeholder="请选择"
            size="mini"
            @change="queryAdIdeas"
          >
            <el-option key="" label="全部" value=""></el-option>
            <el-option
              v-for="item in timeArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col> -->
      </el-row>
    </div>
    <div class="main">
      <div class="meta">
        <div>共筛选出{{ ideaCount }}条文案 <span v-if="!!updateTime"> 更新时间：{{ updateTime }}</span></div>
      </div>
      <div>
        <el-table class="table" :data="tableData" style="width: 100%">
          <el-table-column prop="title" label="文案" class-name="title">
          </el-table-column>
          <el-table-column prop="tags" label="文案类型" width="180">
            <template slot-scope="scope">
              {{ genTags(scope.row.tags) }}
            </template>
          </el-table-column>
          <el-table-column prop="materialNum" label="对应素材数" width="120">
          </el-table-column>
          <el-table-column label="操作" class-name="operator" width="160">
            <template slot-scope="scope">
              <a
                class="copy"
                :class="'copy' + scope.row.id"
                @click="copy('copy' + scope.row.id)"
                :data-clipboard-text="scope.row.title"
                >复制</a
              >
              <el-divider direction="vertical"></el-divider>
              <router-link :to="{ path: '/adideas-detail?id=' + scope.row.id }"
                >查看素材</router-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pager">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="10"
        layout="prev, pager, next, jumper"
        :total="ideaCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import Clipboard from "clipboard";
export default {
  name: "AdIdeas",
  mounted() {
    this.queryFilter();
    this.queryAdIdeas();
  },
  data() {
    return {
      search: "",
      industry: "",
      type: "",
      time: "",
      ideaCount: 0,
      updateTime: "",
      timeArr: [
        {
          value: "1",
          label: "近30天",
        },
        {
          value: "2",
          label: "近90天",
        },
      ],
      industyArr: [],
      typeArr: [],
      tableData: [],
      currentPage: 1,
    };
  },
  methods: {
    queryFilter() {
      this.$http.get("/fireeye/copywriting/search/config").then((res) => {
        console.log(res);
        let data = res.data;
        if (data.code == 1) {
          this.industyArr = data.data.industryList;
          this.typeArr = data.data.typeList;
        }
      });
    },
    queryAdIdeas() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
      });
      let option = {
        industy: this.industry,
        type: this.type,
        page: this.currentPage,
        num: 10,
      };
      this.$http
        .post("/fireeye/copywriting/rank", qs.stringify(option))
        .then((res) => {
          console.log(res);
          let data = res.data;
          if (data.code == 1) {
            this.tableData = data.data.list;
            this.ideaCount = data.data.num;
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    handleSizeChange() {},
    handleCurrentChange() {
      this.queryAdIdeas();
    },
    copy(selector) {
      const clipboard = new Clipboard("." + selector);
      clipboard.on("success", (e) => {
        this.$message.success("已复制到剪贴板！");
        clipboard.destroy();
      });
    },
    genTags(tags) {
      let l = tags.length;
      var str = "";
      for (let i = 0; i < l; i++) {
        str += tags[i];
        if (i != l - 1) {
          str += "，";
        }
      }
      return str;
    },
  },
};
</script>
<style lang="less" scoped>
.filter {
  padding: 25px 15px;
  box-shadow: 0 0 5px #ddd;
  border-radius: 6px;
  font-size: 12px;
  background-color: #fff;

  .row {
    height: 60px;
    line-height: 60px;
    overflow: hidden;

    .col {
      text-align: left;
    }
  }
}
.main {
  .meta {
    text-align: left;
    font-size: 12px;
    height: 60px;
    line-height: 60px;
  }
  .table {
    border: 1px solid #ddd;
    .operator {
      a {
        text-decoration: none;
      }
    }
    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }
    .copy {
      cursor: pointer;
    }
  }
}
.pager {
  margin: 30px 0 60px;
}
</style>